export default "__VITE_ASSET__BfqVQskJ__"